import React from "react";

import FusionCharts from "fusioncharts";
import ReactFusioncharts from "react-fusioncharts";

import charts from "fusioncharts/fusioncharts.charts";

import FusionTheme from "fusioncharts/themes/fusioncharts.theme.fusion";

import ReactFC from "react-fusioncharts";
import Widgets from "fusioncharts/fusioncharts.widgets";

import "./data.css";

ReactFC.fcRoot(FusionCharts, Widgets, FusionTheme);

charts(FusionCharts);

const DataTemperature = (props) => {
  const dataSource = {
    chart: {
      caption: "Satellite Temperature",
      subcaption: "Degree Celsius",
      lowerlimit: "120",
      upperlimit: "200",
      numbersuffix: "°C",
      // thmfillcolor: "#008ee4",
      thmfillcolor: "#e44900",
      showgaugeborder: "1",
      gaugebordercolor: "#FF6384",
      gaugeborderthickness: "2",
      plottooltext: "Temperature: <b>$datavalue</b> ",
      theme: "fusion",
      showvalue: "1",
    },
    value: props.temperature,
  };
  let centerAlign = {
    display: "flex",
    justifyContent: "center",
  };
  return (
    <div className="data-page">
      <ReactFusioncharts
        type="thermometer"
        dataFormat="JSON"
        dataSource={dataSource}
      />
    </div>
  );
};

// class DataTemperature extends React.Component {
//   render() {
//     return (
//       <ReactFusioncharts
//         type="thermometer"
//         width="100%"
//         height="100%"
//         dataFormat="JSON"
//         dataSource={dataSource}
//       />
//     );
//   }
// }
export default DataTemperature;

// import React from "react";
// import GaugeChart from "react-gauge-chart";
// import "./data.css";

// const DataTemperature = () => {
//   let centerAlign = {
//     display: "flex",
//     justifyContent: "center",
//   };
//   return (
//     <div className="data-page">
//       <div className="angular-velocity">
//         <div className="angular-container" style={centerAlign}>
//           <GaugeChart
//             id="gauge-chart1"
//             percent={70 * 0.01}
//             nrOfLevels={30}
//             colors={["#E7E7E7", "#FF7A77"]}
//             textColor="#FF7A77"
//             needleColor="rgba(231, 111, 111, 0.448)"
//             needleBaseColor="#FF7A77"
//           />
//         </div>
//         <span style={centerAlign}>Temperature</span>
//       </div>
//     </div>
//   );
// };

// export default DataTemperature;
